document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-video-section]').forEach(videoSection => {
    const videoPauseButton = videoSection.querySelector('[data-video-section-pause]')
    const videoPlayButton = videoSection.querySelector('[data-video-section-play]')
    const videoElement = videoSection.querySelector('[data-video-section-tag]')
    
    if (!videoPauseButton || !videoPlayButton || !videoElement) {
      return
    }

    const toggleVideoPlayback = () => {
      if (videoElement.paused) {
        videoElement.play()
        videoPlayButton.classList.add('hidden')
        videoPauseButton.classList.remove('hidden')
      } else {
        videoElement.pause()
        videoPauseButton.classList.add('hidden')
        videoPlayButton.classList.remove('hidden')
      }
    }

    videoPauseButton.addEventListener('click', toggleVideoPlayback)
    videoPlayButton.addEventListener('click', toggleVideoPlayback)
  })
})